module.exports = __webpack_public_path__ + "assets/images/novasports_extra3.5ac1d44fd19ef5dd807a65ff77026743.png";